export default "__VITE_ASSET__BsArc1ir__"